/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RvSearchDto } from '../../models/rv-search-dto';
import { RvSearchFormDto } from '../../models/rv-search-form-dto';

export interface RvSearch$Params {
  form: RvSearchFormDto;
  customerGUID: string;
}

export function rvSearch(http: HttpClient, rootUrl: string, params: RvSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RvSearchDto>>> {
  const rb = new RequestBuilder(rootUrl, rvSearch.PATH, 'get');
  if (params) {
    rb.query('form', params.form, {});
    rb.query('customerGUID', params.customerGUID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RvSearchDto>>;
    })
  );
}

rvSearch.PATH = '/rv/search';
